import { defineStore } from 'pinia';

export const usePathsStore = defineStore('pathsStore', {
  state: () => ({ paths: [] }),
  actions: {
    hasName(name) { return this.paths.some(p => p.name === name); },
    add(obj) { this.paths.push(obj); },
  },
});
